import axios from "axios";
import { FETCH_PSGENERIC, HANDLE_ERRORS, LOADING_MODE } from "./types";
import BASE_URL from '../helpers/base-url';
import authorizeRequest from "../helpers/authorize-request";

export const getPSGeneric = () => async dispatch => {
  try {
    dispatch({ type: LOADING_MODE, payload: true, meta: { type: 'genericPs' } });
    const response = await axios.get(
      `${BASE_URL}/api/file/peak_shaving_generic`,
      authorizeRequest()
    );

    dispatch({
      type: HANDLE_ERRORS,
      payload: { message: "", open: false }
    });
    await dispatch({
      type: FETCH_PSGENERIC,
      payload: response
    });
    dispatch({ type: LOADING_MODE, payload: false, meta: { type: 'genericPs' } });
  } catch (error) {
    console.error("error fetching peak shaving generic", error);
    dispatch({
      type: HANDLE_ERRORS,
      payload: { message: error.message, open: true }
    });
    dispatch({ type: LOADING_MODE, payload: false, meta: { type: 'genericPs' } });
  }
};



// WEBPACK FOOTER //
// ./src/actions/getPSGeneric.js